const todosOption = {
  value: 'TODOS',
  label: 'Todos',
};
export {todosOption};
